<template>
  <div>
    <Modal v-model="repositoryDetailsModal" :title="$t('key1002426')" width="1000" class-name="commonModalStyles"
      :transfer="false" :mask-closable="false">
      <div class="details_box_styles">
        <!--基础信息-->
        <div class="basic_information_box">
          <Card :bordered="false" dis-hover>
            <template #title>
              <h2 class="title_box">{{ $t('key1002350') }}</h2>
            </template>
            <Row type="flex" :gutter="gutterItem">
              <Col :span="12" class="basic_item">
                <span class="basic_title">{{ $t('key1002327') }}</span>
                <span class="basic_txt" :title="warehouseName">{{ warehouseName }}</span>
              </Col>
              <Col :span="12" class="basic_item">
                <span class="basic_title">{{ $t('key1002351') }}</span>
                <span class="basic_txt">{{ warehouseForm.deliveryPlaceName }}</span>
              </Col>
              <Col :span="12" class="basic_item">
                <span class="basic_title">{{ $t('key1002352') }}</span>
                <span class="basic_txt">{{ warehouseCode }}</span>
              </Col>
            </Row>
          </Card>
        </div>
        <!--仓库发货可用物流-->
        <div class="basic_information_box">
          <Card :bordered="false" dis-hover>
            <template #title>
              <h2 class="title_box">{{ $t('key1006451') }}</h2>
            </template>
            <Tabs type="card" :animated="false" v-model="logisticsChannelsType">
              <TabPane v-for="(item,index) in availableLogisticsList" :label="item.name" :name="item.logisticsChannelsType">
                <template v-for="(ele,idx) in item.list">
                  <span v-if="ele.key === 'ymsEnableCarrier'" class="display-inline-block mb8 mr20 distributorThemeColor cursor"
                    @click="$refs['logisticsChannel'].initYmsLogisticsChannelData('look', ele.ymsLogisServiceId)">
                    {{ ele.carrierName }}
                  </span>
                  <div v-else>
                    <p class="mb8">
                      <span>{{ ele.carrierName + '：' }}</span>
                      <span class="greenColor cursor" @click="logisticsExpandBtn(index,idx)">{{ ele.expand ? $t('key1000141') : $t('key1006351') }}</span>
                    </p>
                    <template v-if="ele.expand">
                       <span class="display-inline-block mb8 mr20 distributorThemeColor cursor" v-for="k in ele.carrierShippingMethodList"
                         @click="viewLogisticsChannels(ele, k)">
                      {{ k.carrierShippingMethodName }}
                    </span>
                    </template>
                  </div>
                </template>
              </TabPane>
            </Tabs>
          </Card>
        </div>
        <!--仓库地址-->
        <div class="basic_information_box">
          <Card :bordered="false" dis-hover>
            <template #title>
              <h2 class="title_box">{{ $t('key1002364') }}</h2>
            </template>
            <!--发货地址-->
            <h3 class="color-333 pl20 font-size-13">{{ $t('key1002365') }}</h3>
            <Divider style="margin: 8px 0 14px 0"/>
            <Row type="flex" :gutter="gutterItem" class="basic_information_box pl62 font-size-12" v-if="addressDetails && Object.keys(addressDetails).length >0">
              <Col :span="12" class="basic_item" v-for="ele in addressInfoList" style="line-height: initial;">
                <span class="basic_title">{{ ele.title + '：' }}</span>
                <span class="basic_txt" :title="addressDetails[ele.paramsKey]">{{ addressDetails[ele.paramsKey] || '--' }}</span>
              </Col>
            </Row>
            <!--退货地址-->
            <h3 class="color-333 mt30 pl20 font-size-13">{{ $t('key1002366') }}</h3>
            <Divider style="margin: 8px 0 14px 0"/>
            <Row type="flex" :gutter="gutterItem" class="basic_information_box pl62 font-size-12" v-if="returnAddressDetails && Object.keys(returnAddressDetails).length >0">
              <Col :span="12" class="basic_item" v-for="ele in addressInfoList" style="line-height: initial;">
                <span class="basic_title">{{ ele.title + '：' }}</span>
                <span class="basic_txt" :title="returnAddressDetails[ele.paramsKey]">{{ returnAddressDetails[ele.paramsKey] || '--' }}</span>
              </Col>
            </Row>
          </Card>
        </div>
      </div>
      <template #footer>
        <Button type="primary" @click="repositoryDetailsModal = false">{{ $t('key1000248') }}</Button>
      </template>
    </Modal>
    <!--YMS物流渠道弹窗-->
    <ymsLogisticsChannelModal ref="logisticsChannel"></ymsLogisticsChannelModal>
    <!--分销商物流渠道弹窗-->
    <ownLogisticsChannelModal ref="ownLogisticsChannel"></ownLogisticsChannelModal>
    <!--供应商物流渠道弹窗-->
    <ownLogisticsChannelsModal ref="ownLogisticsChannels"></ownLogisticsChannelsModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {_handleMultilingualFields, getAllMatchingLogisticsData, setConfigCharacters} from "@/utils/common";
import ymsLogisticsChannelModal from "@/views/yms/components/logisticsManage/ymsLogisticsChannelModal.vue";
import ownLogisticsChannelModal from "@/views/distributor/components/logisticsManage/ownLogisticsChannelModal.vue";
import ownLogisticsChannelsModal from "@/views/supplier/components/warehouseLogistics/ownLogisticsChannelsModal.vue";


export default {
  name: 'repositoryDetailsModal',
  mixins: [Mixin],
  props: {
    countrysOriginalData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    let v = this;
    return {
      repositoryDetailsModal: false,
      warehouseForm: {},
      addressDetails: {},
      returnAddressDetails: {},
      addressInfoList: [
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002331'), paramsKey: 'name'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002332'), paramsKey: 'countryCodeName'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002333'), paramsKey: 'state'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002334'), paramsKey: 'city'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002335'), paramsKey: 'district'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002336'), paramsKey: 'street'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002337'), paramsKey: 'street2'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002338'), paramsKey: 'street3'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002339'), paramsKey: 'phone'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002340'), paramsKey: 'postcode'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002341'), paramsKey: 'company'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002342'), paramsKey: 'email'},
      ],
      logisticsChannelsType: 'ymsLogistics',
      availableLogisticsList: [],
    }
  },
  computed: {
    warehouseName() {
      return this.warehouseForm.aliasWarehouseName || this.warehouseForm.name;
    },
    warehouseCode() {
      return this.warehouseForm.aliasWarehouseCore || this.warehouseForm.code;
    },
  },
  methods: {
    // 初始化数据
    initRepositoryDetailsData(obj) {
      this.availableLogisticsList = [];
      this.logisticsChannelsType = 'ymsLogistics';
      let {ymsWarehouseId} = obj;
      this.axios.get(api.get_ymsDistributorWarehouse + ymsWarehouseId).then((response) => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          data.name = _handleMultilingualFields(data.name);
          if (data) {
            this.warehouseForm = {...data, deliveryPlaceName: obj.deliveryPlaceName};
            // 仓库地址
            let ymsWarehouseAddress = data.ymsWarehouseAddress ?? [];
            if (ymsWarehouseAddress.length > 0) {
              const addressMap = {};
              ymsWarehouseAddress.forEach(item => {
                const country = this.countrysOriginalData.find(c => c.twoCode === item.countryCode);
                addressMap[item.addressType] = {
                  ...item,
                  countryCodeName: country ? country.cnName : undefined
                };
              });
              this.addressDetails = addressMap.sender || {};
              this.returnAddressDetails = addressMap.return || {};
            }
            // 可用物流
            let ymsWarehouseId = data.ymsWarehouseId;
            if (ymsWarehouseId) {
              getAllMatchingLogisticsData({warehouseIds: [ymsWarehouseId]}, 'distributorCarrier').then((newData) => {
                const mapByType = {};
                newData.forEach((item) => {
                  const logisticsData = item.logisticsData || [];
                  logisticsData.forEach((ele) => {
                    // yms物流
                    if (['ymsEnableCarrier', 'supplierEnableCarrier'].includes(ele.key)) {
                      const typeKey = 'ymsLogistics';
                      if (!mapByType[typeKey]) {
                        mapByType[typeKey] = {
                          name: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001581')}`,
                          logisticsChannelsType: typeKey,
                          expand: false,
                          list: []
                        };
                      }
                      if (ele.key === 'ymsEnableCarrier') {
                        const items = ele.list.map((k) => ({
                          ...k,
                          carrierName: k.name,
                          key: ele.key
                        }));
                        mapByType[typeKey].list = mapByType[typeKey].list.concat(items);
                      } else {
                        const items = ele.carrierData.map((k) => ({
                          ...k,
                          carrierName: k.carrierName,
                          key: ele.key
                        }));
                        mapByType[typeKey].list = mapByType[typeKey].list.concat(items);
                      }
                    }
                    // 自有物流
                    else {
                      const typeKey = 'selfOwnedLogistics';
                      if (!mapByType[typeKey]) {
                        mapByType[typeKey] = {
                          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001587'),
                          logisticsChannelsType: typeKey,
                          expand: false,
                          list: []
                        };
                      }
                      const items = ele.carrierData.map((k) => ({
                        ...k,
                        carrierName: k.carrierName,
                        key: ele.key
                      }));
                      mapByType[typeKey].list = mapByType[typeKey].list.concat(items);
                    }
                  });
                });
                const newList = Object.values(mapByType);
                this.availableLogisticsList = newList;
                this.repositoryDetailsModal = true;
              });
            }
          }
        }
      });
    },
    // 展开与收起物流渠道
    logisticsExpandBtn(index, idx) {
      this.availableLogisticsList[index].list[idx].expand = !this.availableLogisticsList[index].list[idx].expand;
      this.$forceUpdate();
    },
    // 查看物流渠道
    viewLogisticsChannels(ele, k) {
      if (ele.key === 'distributorEnableCarrier') {
        this.$refs['ownLogisticsChannel'].ownLogisticsChannelFun(k.shippingMethodId, 'look');
      } else if (ele.key === 'supplierEnableCarrier') {
        this.$refs['ownLogisticsChannels'].initSupplierLogisticsChannelData('look', k.shippingMethodId, ele.merchantId);
      }
    }
  },
  watch: {},
  components: {
    ownLogisticsChannelsModal,
    ownLogisticsChannelModal,
    ymsLogisticsChannelModal
  }
};
</script>

<style lang="less">
.commonModalStyles /deep/ {
  .details_box_styles {
    .ivu-card-head {
      padding: 0 0 10px 0;
    }

    .title_box {
      font-size: 14px;
    }
  }

  .basic_txt {
    max-width: 260px !important;
  }
}
</style>
